import { InfoBanner, InfoHeaderIcon } from "../components/Shared/InfoBanner";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { Colour } from "../Variables";
import { PositionsFiltered } from "../components/Positions/PositionsFiltered";
import { LeftHandMenu } from "../components/LeftHandMenu";
import { ImageCarousel } from "../components/ImageCarousel";
import { PositionsModel, API_GetPositionOverview } from "../../apis/ApisPositions";

export function PositionsListIntranet() {
    const app = useContext(AppContext);
    const [positions, setPositions] = useState<PositionsModel>(null);

    useEffect(() => {
        async function asyncCall() {
            var positions = await API_GetPositionOverview(app.token, true);
            setPositions(positions);
        }
        if (!app.loading && app.baseFeatures.IsIntranetDisplay) {
            asyncCall();
        }
    }, [app.loading]);

    return (
        <>
            {!app.redesign_Carousel &&
                <InfoBanner
                    header="Intranet job board"
                    narrow={false}
                    icon={InfoHeaderIcon.Positions}
                    info="All current internal opportunities"
                    subHeader={`${app.firmName} online application system`}
                    theme={Colour.White}>
                </InfoBanner>}

            {app.redesign_Carousel && <ImageCarousel />}

            <LeftHandMenu mobileOnly={false} />

            {positions != null && <PositionsFiltered intra={true} positions={positions} />}
        </>
    );
}